var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/account_timeline/components/moved_note.tsx";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router-dom';
import AvatarOverlay from 'soapbox/components/avatar_overlay';
import DisplayName from 'soapbox/components/display-name';
import Icon from 'soapbox/components/icon';
const MovedNote = ({
  from,
  to
}) => {
  const displayNameHtml = {
    __html: from.display_name_html
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "account__moved-note",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "account__moved-note__message",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "account__moved-note__icon-wrapper",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/briefcase.svg'),
    className: "account__moved-note__icon",
    fixedWidth: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 22,
      columnNumber: 60
    }
  })), /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "account.moved_to",
    defaultMessage: "{name} has moved to:",
    values: {
      name: /*#__PURE__*/React.createElement("bdi", {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 23,
          columnNumber: 103
        }
      }, /*#__PURE__*/React.createElement("strong", {
        dangerouslySetInnerHTML: displayNameHtml,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 23,
          columnNumber: 108
        }
      }))
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(NavLink, {
    to: `/@${to.acct}`,
    className: "detailed-status__display-name",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "detailed-status__display-avatar",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(AvatarOverlay, {
    account: to,
    friend: from,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 58
    }
  })), /*#__PURE__*/React.createElement(DisplayName, {
    account: to,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 9
    }
  })));
};
export default MovedNote;